import React from 'react';

import { Box, Card, IconButton, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../features/track';
import { ContentCardProps } from '../data';

const LegalBanner: React.FC<ContentCardProps> = ({
  description,
  linkText,
  dismissible,
  url,
  handleDismissal,
  handleCardClick,
  trackingModule: eventModule,
  trackingFlow: eventFlow,
  extras: { name: eventName, linkTarget },
}) => {
  return (
    <Card css={{ p: 'space.200', maxWidth: '120rem', mx: 'auto' }}>
      <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box css={{ display: 'flex', alignItems: 'center' }}>
          <Box css={{ mr: 'space.200' }}>
            {description && <Text variant="text100" dangerouslySetInnerHTML={{ __html: description }} />}
            {url && linkText && (
              <>
                {' '}
                <SambaAutoLink
                  to={url}
                  target={linkTarget}
                  rel="noopener noreferrer"
                  onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                    trackClick({ name: `${eventName}_${linkText}`, module: eventModule, flow: eventFlow });
                    handleCardClick(event);
                  }}
                  data-testid="contentCardLink"
                >
                  {linkText}
                </SambaAutoLink>
              </>
            )}
          </Box>
        </Box>
        {dismissible && (
          <IconButton
            css={{ display: 'flex' }}
            label="Dismiss card"
            onClick={handleDismissal}
            name="X"
            color="icon.weak"
          />
        )}
      </Box>
    </Card>
  );
};

export default LegalBanner;
